/**
 * Auto-generated by yarn cross-type:gen-typescript. Do not edit by hand.
 *
 * @source dashboard/lib/shared/braze/remote_lookup/providers/sparse_segment_remote_lookup_provider.rb
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../../../../common";

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/sparse_segment_remote_lookup_provider.rb) */
export const itemTypeSchema = z.strictObject({
  id: common.objectId,
  name: z.string(),
  is_archived: z.boolean().nullable().optional(),
  is_global_control: z.boolean().nullable().optional(),
  is_user_defined: z.boolean().nullable().optional(),
  is_non_retargetable: z.boolean().nullable().optional(),
  contains_segment_membership: z.boolean().nullable().optional(),
  estimated_size: z.int().nullable(),
});

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/sparse_segment_remote_lookup_provider.rb) */
export const itemTypeOutputSchema = z.object({
  id: common.objectId,
  name: z.string(),
  is_archived: z.boolean(),
  is_global_control: z.boolean(),
  is_user_defined: z.boolean(),
  is_non_retargetable: z.boolean(),
  contains_segment_membership: z.boolean(),
  estimated_size: z.int().nullable(),
});
